const React = require('react');

class LargeLogo extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 574 251.66" className={this.props.className}>
                <g id="Layer_2" data-name="Layer 2">
                    <g id="Logo">
                        <path className="cls-1" fill="#5c1500" d="M95.73,105.81V198H86.38V124.24l-36.21,62H45.56L9.35,124.64V198H0V105.81H8l40,68.34,39.63-68.34Z"/>
                        <path className="cls-1" fill="#5c1500" d="M199.89,173.36H148.54L137.48,198H127.34l42.13-92.17h9.62L221.22,198H211Zm-3.56-7.9L174.21,116l-22.12,49.51Z"/>
                        <path className="cls-1" fill="#5c1500" d="M279,166.11V198h-9.61V166.11l-36.87-60.3H243l31.6,51.75,31.6-51.75h9.74Z"/>
                        <path className="cls-1" fill="#5c1500" d="M399.79,173.36H348.43L337.37,198H327.23l42.14-92.17H379L421.12,198H410.85Zm-3.56-7.9L374.11,116,352,165.46Z"/>
                        <path className="cls-1" fill="#5c1500" d="M567.45,3.52,493.16,43.45l65.08,20.91c-1.66,5.64-28,94.79-29.73,100.52L447.85,141.5c1.64-5.63,21-72.65,22.68-78.27l59.74,17.21-17.09,57.78-38.53-10.51C476.17,122.6,484.34,95,485.82,90l18.78,5.56c-1.56,4.93-7.33,23.23-7.33,23.23l6.28,2,9.34-29.62-31.51-9.32-14.94,50.5,51.22,14L538.46,76,466,55.09s-.3,1-.57,2L427.83,81.24s17.6,39.42,18.53,41.49c-.59,2.06-5.74,20.09-5.74,20.1s-.91,3.16-.91,3.16l3.14.91,16.71,5,45,99.79s23.92-73.94,25.69-79.44l2.75.8,33.41-113-3-1-3.8-1.27C560.86,52.54,574,0,574,0l-6.55,3.52M564,12.84l-10.76,43L509.9,41.92,564,12.84M462.69,66.67c-2.41,8.31-7.31,25.23-13.45,46.39l-13.1-29.34,26.55-17m5.1,87.46,56.1,16.26c-1.67,5.16-16.41,50.76-20.38,63l-35.72-79.28"/>
                    </g>
                </g>
            </svg>
        )
    }
}

module.exports = LargeLogo;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/LargeLogo/index.jsx